const features = [
  {
    icon: 'ri-money-cny-circle-line',
    title: '完全免费',
    desc: '无需注册、无需付费，所有91电影免费资源直接播放，让观影零门槛。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P高清播放，画面清晰细腻，带来影院级的视觉享受。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录数万部国产电影免费大片，每日持续更新50+部新片。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用CDN加速技术，打开即播，告别卡顿等待，流畅观影体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '电脑、平板、手机全终端自适应，91电影免费看随时随地。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            特色优势
          </h2>
          <p className="text-foreground-500 text-sm">五大优势，畅享免费观影</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 text-center hover:bg-background-200/70 transition-colors group cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-500 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}